import NiceModal from "@ebay/nice-modal-react";
import { storeRequester } from "App";
import AdminCustomButton, { style } from "components/buttons/AdminCustomButton";
import Dummy from "components/Dummy";
import InputPassword from "components/inputs/InputPassword";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const CustomerPasswordChangeModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(80%, 400px)", "290px"];
  const withCloseButton = false;
  const clickOutsideToClose = false;
  const title = "비밀번호 변경";
  const buttonText = t("close");
  const modal = useRef();
  // const inputs = useRef([]);
  const input = useRef();
  const [valid, setValid] = useState(false);
  /*
    props format
    {
        buttons : object / for make buttons
        mesage: string / text for showing this modal's description
        data: any / transfer data to Click, if u want more data, Do update data
    }
    //
    buttons format
    {
        text : string / button's name
        style : object / button's style
        onClick: function / button action, whethere async or not
        close: boolean / if true , press with close modal, default : true
    }
 */
  useEffect(() => {
    // 모달이 열렸을 때 body 스크롤 비활성화
    document.body.style.overflow = "hidden";

    // 모달이 닫힐 때 복구
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  const onSaveClick = () => {
    storeRequester.updateCustomer({
      password: input.current.getValue(),
      resetPassword: false
    }, (result) => {
      if (!result.customer.resetPassword) {
        toast.success(t("수정되었습니다"), {
          autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
        });
        modal.current.close();
      }
    });

  };
  // const onCancelClick = () => {
  //   modal.current.close();
  // };
  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      // withHeader={withHeader}
      withFooter={withFooter}
      // withCloseButton={withCloseButton}
      clickOutsideToClose={!props.isForced}
      title={title}
      buttonText={buttonText}
    >
      {/* <PaddingWrapper padding={"10px 20px"}> */}
        <VerticalFlex gap={10} height={"100%"}>
          {/* <FlexChild>
            <InputText
              placeHolder="새 비밀번호"
              ref={(el) => (inputs.current[0] = el)}
              type="password"
            />
          </FlexChild>
          <FlexChild>
            <InputText
              placeHolder="비밀번호 확인"
              ref={(el) => (inputs.current[1] = el)}
              type="password"
              manualValid
              onChange={(value) =>
                setValid(value ? value === inputs.current[0].getValue() : null)
              }
              feedback="비밀번호가 일치하지 않습니다."
            />
          </FlexChild> */}
          <FlexChild padding={"10px 20px"} height={"fit-content"} alignItems={"flex-start"} justifyContent={"flex-start"} borderBottom={"3px solid grey"} backgroundColor={"#f2f2f2"}>
          <P weight={'bold'}>비밀번호 변경</P>
          </FlexChild>
          <FlexChild padding={"10px 20px"}>
            <InputPassword
              signUp
              confirmVisible
              placeHolder="새비밀번호"
              placeHolderComfirm="비밀번호 확인"
              onMatch={(value) => setValid(value)}
              ref={input}
            />
          </FlexChild>
          <FlexChild height={"fit-content"} padding={"10px 20px"}>
          {props.isForced ? (
            <P color={"red"}>보안을 위해 최초 1회 비밀번호 변경이 필요합니다.
              비밀번호 변경 후 월드베이프 서비스 이용이 가능합니다.</P>
          ) : (
            <Dummy height={40}/>
          )}
        </FlexChild>
          <FlexChild padding={"10px 20px"}>
            <HorizontalFlex gap={10} height={"fit-content"} alignItems={"flex-start"}>
              {/* <AdminCustomButton
                style={style.white_border}
                text="취소"
                onClick={onCancelClick}
              /> */}
              <FlexChild height={"fit-content"} justifyContent="flex-end">
                <AdminCustomButton
                  style={style.white_border}
                  text="변경"
                  onClick={onSaveClick}
                  disabled={!valid}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
        </VerticalFlex>
      {/* </PaddingWrapper> */}
    </ModalBase>
  );
});

export default CustomerPasswordChangeModal;
